import {Box, Clickable, HStack, Icon, Show, Text, ThemeColorTextPath} from 'platform/foundation';

import {isNil, isNotNil} from 'ramda';

import {ParameterItem} from './types/ParameterItem';

export type ParametersItemProps = ParameterItem;

export function ParametersItem(props: ParametersItemProps) {
  const variant = props.variant || 'primary';
  const iconColor = `text.${variant}` as `text.${ThemeColorTextPath}`;

  const itemContent = (
    <HStack spacing={1} align="center">
      <Show when={isNotNil(props.icon)}>
        <Icon value={props?.icon} size={4} color={iconColor} isNotFilled={props.isIconNotFilled} />
      </Show>
      {isNotNil(props.content) ? (
        <Box data-testid={props['data-testid']}>{props.content}</Box>
      ) : (
        <Show when={isNotNil(props.title)}>
          <Text
            data-testid={props['data-testid']}
            color={props.variant}
            size={props.size}
            noWrap
            alternative={props.alternative}
            {...props.parametersProps}
          >
            {props.title}
          </Text>
        </Show>
      )}
    </HStack>
  );

  // A disabled Clickable applies `pointer-events: none` and `user-select: none`,
  // which would make the text of an inert parameter impossible to select or copy.
  if (isNil(props.onClick)) {
    return itemContent;
  }

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    props.onClick?.(e);
  };

  return (
    <Clickable data-testid={props['data-testid']} onClick={handleClick}>
      {itemContent}
    </Clickable>
  );
}
